import { render, staticRenderFns } from "./UpArrowKeyIcon.vue?vue&type=template&id=0eba2f14&scoped=true"
import script from "./UpArrowKeyIcon.vue?vue&type=script&lang=js"
export * from "./UpArrowKeyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eba2f14",
  null
  
)

export default component.exports